import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  name: 'RouterHolder',
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  computed: _objectSpread({}, mapGetters('router', ['keepAliveList'])),
  created: function created() {
    console.log('created RouterHolder');
  },
  activated: function activated() {
    var _this = this;

    console.log('activated RouterHolder');
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};